<div class="jsd-core">
    <header>
        <nav>
            <div class="menu-mobile">
                <div class="menu-mobile-action">
                    <button class="btn-icon" (click)="menuToggle()">
                        <jsd-icon *ngIf="!getMenuOpen()" iconName="menu"></jsd-icon>
                        <jsd-icon *ngIf="getMenuOpen()" iconName="close" height="24px" width="24px"></jsd-icon>
                    </button>
                </div>

                <a class="btn-link" routerLink="/inicio" (click)="menuCLose()">
                    <jsd-icon iconName="logo-pra-ja-white" width="56px"></jsd-icon>
                </a>

                <div class="go-to-app">
                    <a class="btn-link"
                       href="https://play.google.com/store/apps/details?id=br.com.jamesdelivery.android.courier&pcampaignid=web_share">
                        <jsd-icon iconName="android"></jsd-icon>
                    </a>
                </div>
            </div>

            <ul class="menu-mobile-panel" *ngIf="getMenuOpen()">
                <li><a class="btn btn-link" routerLink="/inicio" routerLinkActive="link-active" (click)="menuCLose()">
                    Inicio</a></li>
                <li><a class="btn btn-link"
                       href="https://app.pipefy.com/portals/portal-do-entregador">Quero ser entregador</a></li>
                <li><a class="btn btn-link" routerLink="/faq" routerLinkActive="link-active" (click)="menuCLose()">
                    Contato e ajuda</a></li>
                <li><a class="btn btn-link" routerLink="/politica-de-privacidade" routerLinkActive="link-active"
                       (click)="menuCLose()">
                    Política de Privacidade</a></li>
                <li><a class="btn btn-link" routerLink="/termo-de-uso" routerLinkActive="link-active"
                       (click)="menuCLose()">
                    Termo de Uso</a></li>
            </ul>

            <div class="desktop">
                <div class="menu-items">
                    <a class="btn-link" routerLink="/inicio" style="justify-self: start" (click)="menuCLose()">
                        <jsd-icon iconName="logo-pra-ja" width="126px" height="56px"></jsd-icon>
                    </a>
                    <a href="https://app.pipefy.com/portals/portal-do-entregador">Quero ser entregador</a>
                    <a routerLink="/faq" routerLinkActive="link-active" (click)="menuCLose()"> Contato e ajuda</a>
                </div>
                <div class="menu-other">
                    <div class="menu-container">
                        <div class="menu-items-2">
                            <a routerLink="/politica-de-privacidade" routerLinkActive="link-active-on"
                               (click)="menuCLose()">Política de Privacidade</a>
                            <a routerLink="/termo-de-uso" routerLinkActive="link-active-on" (click)="menuCLose()">Termo
                                de Uso</a>
                        </div>
                        <div class="go-to-app">
                            <a class="btn-link"
                               href="https://play.google.com/store/apps/details?id=br.com.jamesdelivery.android.courier&pcampaignid=web_share">
                                <jsd-icon iconName="android" width="48px" height="48px"></jsd-icon>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </nav>
    </header>

    <main class="main">
        <router-outlet></router-outlet>
    </main>

    <footer>
        <p>2024 © O James é uma empresa do Grupo Pão de Açúcar.</p>
        <a class="footer-logo" href="https://www.paodeacucar.com/">
            <jsd-icon iconName="logo-gpa"></jsd-icon>
        </a>
    </footer>

</div>